import { Button, Card, Icon, Intent, Tooltip, H3 } from '@blueprintjs/core';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { Research, WavelightsState } from '../../types';
import { useEffect, useState } from 'react';
import { getAllWavelightResearch } from '../../reducer';
import { formatDate } from '../../../../utils';
import Table from '../../../../components/Table';
import { usePaginationSearchParams } from '../../../users/components/pagination/hooks';

interface ResearchTableProps {
  id: string;
}

const ResearchTable = ({ id }: ResearchTableProps) => {
  const { currentPage, setCurrentPage } = usePaginationSearchParams();
  const dispatch = useAppDispatch();
  const { waveLightAlgorithms, research }: WavelightsState = useAppSelector(
    (state) => state.wavelight,
  );

  const [itemsPerPage] = useState(10);

  useEffect(() => {
    if (waveLightAlgorithms.length > 0) {
      dispatch(
        getAllWavelightResearch({
          id: id as string,
          limit: itemsPerPage,
          page: currentPage,
        }),
      );
    }
  }, [dispatch, id, waveLightAlgorithms, currentPage, itemsPerPage]);

  return (
    <Card>
      <H3>Research Algorithm Results Table</H3>
      <Table<Research>
        rowKey="_id"
        data={Array.isArray(research) ? research : []}
        pagination={{
          currentPage,
          totalPages: Math.ceil(
            (Array.isArray(research) ? research.length : 0) / itemsPerPage,
          ),
          onPageChange: (pageNumber) => setCurrentPage(pageNumber),
        }}
        columns={[
          {
            title: 'ID',
            render: (record) => record._id,
          },
          {
            title: 'Analyst',
            render: (record) => record.analyst,
          },
          {
            title: 'BPM',
            render: (record) => record.wavelight_bpm,
          },
          {
            title: 'Oximetry',
            render: (record) => record.wavelight_oximetry,
          },
          {
            title: 'Processed',
            render: (record) => (record.processed ? 'Yes' : 'No'),
          },
          {
            title: 'Processing Duration',
            render: (record) => `${record.processedTime.toFixed(2)} sec`,
          },
          {
            title: 'Created',
            render: (record) => formatDate(record.createdAt),
          },
          {
            title: 'Last Modified',
            render: (record) => formatDate(record.processedAt),
          },
          {
            title: 'Computing',
            render: (record) =>
              record.processed ? <Icon icon="tick" /> : <Icon icon="time" />,
          },
          {
            title: 'Actions',
            render: (record) => (
              <Tooltip
                content={<span>Calculations</span>}
                openOnTargetFocus={false}
                usePortal={false}
              >
                <Button
                  disabled={!record.processed}
                  // onClick={() => openCalculationScreen(record._id)}
                  icon={'function'}
                  intent={Intent.PRIMARY}
                />
              </Tooltip>
            ),
          },
        ]}
      />
    </Card>
  );
};

export default ResearchTable;
